import { ComponentType, FC, SVGProps } from 'react';
import {
  Content,
  DropdownItem,
  DropdownMenu,
  Portal,
  Trigger,
} from 'components/DsDropdown/DropdownMenu';
import styles from './LinkDropdown.module.scss';
import { Pointer } from '@yleisradio/areena-types';
import classNames from 'classnames';
import { Link } from 'components/Link';

export type LinkDropdownData = {
  Icon: FC<SVGProps<SVGAElement>>;
  label: string;
  pointer?: Pointer;
  handleOnClick?: () => void;
  testId?: string;
};

type Props = {
  TriggerIcon: ComponentType;
  data: LinkDropdownData[];
  size: 'sm' | 'md';
  triggerAriaLabel: string;
  triggerTestId?: string;
};

const LinkDropdown: FC<Props> = ({
  TriggerIcon,
  data,
  size,
  triggerAriaLabel,
  triggerTestId,
}) => {
  return (
    <DropdownMenu modal={false}>
      <Trigger
        className={styles.trigger}
        aria-label={triggerAriaLabel}
        data-testid={triggerTestId}
      >
        <TriggerIcon />
      </Trigger>
      <Portal>
        <Content className={styles.list}>
          {data.map((link, index) => {
            const { Icon, testId } = link;

            const itemClasses = classNames(
              styles.itemContainer,
              styles.item,
              styles[`item-size-${size}`]
            );
            return (
              (link.pointer && (
                <DropdownItem key={index} className={itemClasses} asChild>
                  <Link
                    pointer={link.pointer}
                    onClick={link.handleOnClick}
                    data-testid={testId}
                  >
                    <Icon className={styles.icon} aria-hidden />
                    <div className={styles.label}>{link.label}</div>
                  </Link>
                </DropdownItem>
              )) ||
              (link.handleOnClick && (
                <DropdownItem key={index} className={itemClasses} asChild>
                  <button
                    className={itemClasses}
                    onClick={link.handleOnClick}
                    data-testid={testId}
                  >
                    <Icon className={styles.icon} aria-hidden />
                    <div className={styles.label}>{link.label}</div>
                  </button>
                </DropdownItem>
              ))
            );
          })}
        </Content>
      </Portal>
    </DropdownMenu>
  );
};

export { LinkDropdown };
